import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './utility/i18n'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import store from './redux/store'
import './assets/css/index.css'
import 'moment/locale/id'

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
)
serviceWorker.register()
